import { forwardRef, type HTMLAttributes } from 'react';
import { cn } from '../../lib/cn';

export interface SCardProps extends HTMLAttributes<HTMLDivElement> {
  /** 테두리 표시 여부 */
  bordered?: boolean;
}

/** SCard — sd-card 포팅. 라운드 8px, 흰 배경, 옵션 테두리. */
export const SCard = forwardRef<HTMLDivElement, SCardProps>(function SCard(
  { bordered = false, className, children, ...rest },
  ref,
) {
  return (
    <div
      ref={ref}
      className={cn('h-fit rounded-[8px] bg-white', bordered && 'border border-grey-30', className)}
      {...rest}
    >
      {children}
    </div>
  );
});
